import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
})
export class ListComponent implements OnInit {
  breadcrumbs: any;
  officeId: string | null = '';
  dataHistory: any = [];

  constructor(private api: ApiService) {}

  ngOnInit(): void {
    this.api.getRoleValue().subscribe({
      next: (data) => {
        this.officeId = data;
        this.getList(Number(data));
      },
      error: (err) => {},
    });

    this.breadcrumbs = [
      {
        name: 'Agenda',
        path: '/dashboard/new-calendar',
        link: true,
      },
      {
        name: 'Historial de sesiones eliminadas',
        link: false,
      },
    ];
    console.log(this.breadcrumbs);
  }

  getList(officeId: Number) {
    this.api.getById('delete/sessions', Number(officeId)).subscribe({
      next: (data) => {
        this.dataHistory = data.data;
      },
      error: (err) => {},
    });
  }
}
